import http from "@/api";
export const getResolutionListApi = () => {
  return http.get("/public/system/resolution/list");
};
export const getSolutionDetailApi = (id: number) => {
  return http.get("/public/system/resolution/" + id);
};

export const postSolutionApi = (data: any) => {
  return http.post("/public/solution/questionnaire/add", data);
};
